// Function to remove duplicate service packages
export function removeDuplicates(servicePackages) {
  const seen = new Set();
  return servicePackages?.filter((item) => {
    const duplicate = seen.has(item.code);
    seen.add(item.code);
    return !duplicate;
  });
}

// To get default selected car and service in service/coupon package when initial page load
export default function getDefaultCarAndService(serviceType, serviceProductList) {
  // Get first car item
  let defaultCar =
    serviceProductList.find((product) => product?.vehicleName?.includes('A/T')) ||
    serviceProductList[0];

  if (defaultCar?.servicePackage?.length) {
    defaultCar = {
      ...defaultCar,
      servicePackage: removeDuplicates(defaultCar?.servicePackage),
    };
  }

  const defaultService = defaultCar?.[serviceType]?.length ? defaultCar?.[serviceType][0] : {};

  return {
    defaultCar,
    defaultService,
  };
}
